import colors from "../../theme/Colours";

export const mainContainerStyle = {
  display: "flex",
  flexDirection: "column",
  backgroundColor: { xs: "none", sm: colors.background2 },
  px: { xs: 0, sm: "24px" },
  py: { xs: "0px", sm: "30px" },
  boxShadow: { xs: "none", sm: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)" },
  height: "647px",
};

export const textStyle = {
  fontFamily: "Poppins",
  fontSize: { xs: "12px", sm: "16px" },
  fontWeight: 600,
  marginBottom: { xs: "2px", sm: "10px" },
  color: colors.textColor2,
};

export const paytextStyle = {
  ...textStyle,
  color: "#0A0D13",
};

export const headingStyle = {
  ...textStyle,
  fontWeight: 600,
  fontSize: { xs: "10px", sm: "13px", md: "13px" },
  color: colors.greyTextColor,
  marginTop: "10px",
};

export const inputLabelStyle = {
  ...textStyle,
  fontSize: { xs: "12px", sm: "13px", md: "13px" },
  fontWeight: 500,
};
export const uploadButtonContainer = {
  marginTop: "10px",
  width: "92px",
  height: "25px",
  borderRadius: "unset",
};

export const deviderStyle = {
  width: "50%",
  marginTop: 20,
  marginBottom: 20,
};

export const lableAndValueStyle = {
  display: "flex",
  flexDirection: "column",
};

export const greyGridStyle = {
  display: "flex",
  flexDirection: "column",
  background: "#F4F6FA",
  paddingY: "23px",
  paddingX: { xs: 0, sm: "23px" },
  borderRadius: "10px",
  height: "593px",
};

export const uploadPaymentStyle = {
  fontSize: { xs: "10px", sx: "14px" },
  fontWeight: 400,
  fontFamily: "Roboto",
  color: "#161F49",
};

export const fieldTitleStyle = {
  marginBottom: "8px",
  fontSize: "14px",
  fontWeight: 500,
  fontFamily: "Roboto",
};

export const transactionInputStyle = {
  width: "300px",
  height: "43px",
  border: "1px solid #C5CED6",
};
export const makePaymentButtonStyle = {
  height: "55px",
  borderRadius: "30px",
};

export const uploadDocumentStyle = {
  display: "flex",
  alignItems: "center",
  border: "1px solid #767676",
  width: "220px",
  height: "35px",
  marginTop: "16px",
  padding: "10px",
  fontSize: "12px",
  backgroundColor: "#EFEFEF",
  gap: "15px",
};

export const fileUploadStyle = {
  display: "none",
  backgroundColor: "#EFEFEF",
};
